import memo from "fast-memoize";
import hashString from "../utils/hash-string";
import fetch from "./fetch-trade-api";

const accessories = async trimId => {
  const resp = await fetch(`/v1/report/accessories/trim/${trimId}`);
  const json = await resp.json();

  const list = Object.entries(json)
    .map(([key, accessory]) => {
      const { description, tradeInValue } = accessory;
      return {
        ...accessory,
        group: key,
        id: hashString(`${description}${key}`).toString(),
        tradeInValue: parseInt(tradeInValue, 10)
      };
    });
  return list;
};

export async function accessoriesValue(accessoryIds = [], trimId) {
  const accessoryList = await accessories(trimId);
  return accessoryList
    .filter(({ id }) => accessoryIds.includes(id))
    .map(({ tradeInValue }) => tradeInValue)
    .reduce((sum, value) => sum + value, 0);
}

export default memo(accessories);
